// Reviewed against the Virginia Department of Elections candidate list for the
// November 3 2026 general election, federal offices. Captured 2026-10-31,
// sha256 0fd2ca4913f0eba111e695025e50ea20a41da2a3390d623450ef6b503877f967.
//
// IDs are explicit, inspected against production; never match by name. Two
// lineages exist per candidate - an evidence-bearing UUID row and a slug row -
// and the UUID is listed first so its evidence wins when both are loaded.
//
// Two candidates on the certified ballot have no production row and are
// deliberately absent rather than invented:
//   VA-07 Libertarian Taner E. Demirci Lopez
//   VA-08 Libertarian Shelly M. Arnoldi
// Their contests therefore report them as missing, which is the honest answer.
export const VA_GENERAL_2026 = {
  state: 'VA',
  electionYear: 2026,
  verifiedOn: '2026-10-31',
  electionDate: '2026-11-03',
  sourceUrl: 'https://www.elections.virginia.gov/casting-a-ballot/candidate-list/november-3-2026-gen-elect-federal-offices/',
  sourceSha256: '0fd2ca4913f0eba111e695025e50ea20a41da2a3390d623450ef6b503877f967',
  contests: [
    {
      districtKey: null,
      statewide: true,
      entries: [
        {
          name: 'Bert Mizusawa', party: 'Republican', fecId: 'S8VA00321',
          ids: ['7c887e43-40dc-43fd-b240-5f774a74e53b', 'va-sen-statewide-2026-bmizusawa'],
          names: ['Bert Mizusawa', 'Bert K Mizusawa', 'Mizusawa, Bert K'],
        },
        {
          name: 'Mark R. Warner', party: 'Democratic', fecId: 'S6VA00093',
          ids: ['7067bed2-4724-41ed-a8de-49fccc8ca478', 'va-sen-statewide-2026-mwarner'],
          names: ['Mark R. Warner', 'Mark Robert Warner', 'Warner, Mark Robert'],
        },
      ],
    },
    {
      districtKey: 'cd:5101',
      statewide: false,
      entries: [
        {
          name: 'Robert J. "Rob" Wittman', party: 'Republican', fecId: null,
          ids: ['419f6e6f-d7d3-4696-b64e-1416aafd5a4c', 'va-rep-dist1-2026-rwittman'],
          names: ['Robert J. "Rob" Wittman', 'Robert Wittman', 'Wittman, Robert J. Mr.'],
        },
        {
          name: 'Shannon L. Taylor', party: 'Democratic', fecId: 'H6VA01299',
          ids: ['277880a1-2534-4ca7-a238-646a668024ad', 'va-rep-dist1-2026-staylor'],
          names: ['Shannon L. Taylor', 'Shannon Leigh Taylor', 'Taylor, Shannon Leigh'],
        },
      ],
    },
    {
      districtKey: 'cd:5102',
      statewide: false,
      entries: [
        {
          name: 'Elaine G. Luria', party: 'Democratic', fecId: 'H6VA02198',
          ids: ['13789d48-a4e5-49b8-98aa-bfd5c5d30be0', 'va-rep-dist2-2026-eluria'],
          names: ['Elaine G. Luria', 'Elaine Luria', 'Luria, Elaine'],
        },
        {
          name: 'Geral D. "Bishop" Staten', party: 'Independent', fecId: 'H6VA02222',
          ids: ['94d27d05-b92e-46d5-84e8-d8dcc1cd5c2b', 'va-rep-dist2-2026-gstaten'],
          names: ['Geral D. "Bishop" Staten', 'Geral Defrance Mr Staten', 'Staten, Geral Defrance Mr'],
        },
        {
          name: 'J. Matt Baker', party: 'Independent', fecId: null,
          ids: ['va-rep-dist2-2026-mbaker'],
          names: ['J. Matt Baker', 'Baker, Matthew'],
        },
        {
          name: 'Jen A. Kiggans', party: 'Republican', fecId: 'H2VA02064',
          ids: ['9e99e33e-d4d0-4e4f-b17b-f2d3b92890f4', 'va-rep-dist2-2026-jkiggans'],
          names: ['Jen A. Kiggans', 'Jennifer Kiggans', 'Kiggans, Jennifer'],
        },
      ],
    },
    {
      districtKey: 'cd:5103',
      statewide: false,
      entries: [
        {
          name: 'Edwin Rivera, Jr.', party: 'Republican', fecId: 'H6VA03121',
          ids: ['94e50b70-6183-4e48-9dc8-0da4deb177c5', 'va-rep-dist3-2026-erivera'],
          names: ['Edwin Rivera, Jr.', 'Edwin Mr. Jr. Rivera', 'Rivera, Edwin Mr. Jr.'],
        },
        {
          name: 'Makiba A. Gaines', party: 'Independent', fecId: 'H6VA02248',
          ids: ['f8b731cc-ca40-4e4f-9d15-e19cb0f690c2', 'va-rep-dist3-2026-mgaines'],
          names: ['Makiba A. Gaines', 'Makiba Gaines', 'Gaines, Makiba'],
        },
        {
          name: 'Robert C. "Bobby" Scott', party: 'Democratic', fecId: 'H6VA01117',
          ids: ['21ebc436-b1be-45d1-9e6b-dd5f7d49b081', 'va-rep-dist3-2026-rscott'],
          names: ['Robert C. "Bobby" Scott', 'Robert C Scott', 'Scott, Robert C'],
        },
        {
          name: 'Stephen C. Woll', party: 'Independent', fecId: null,
          ids: ['va-rep-dist3-2026-swoll'],
          names: ['Stephen C. Woll', 'Woll, Stephen C.'],
        },
      ],
    },
    {
      districtKey: 'cd:5104',
      statewide: false,
      entries: [
        {
          name: 'Jennifer L. McClellan', party: 'Democratic', fecId: 'H4VA04066',
          ids: ['c27bc075-edb4-4067-ae34-c586f27bd4f7', 'va-rep-dist4-2026-jmcclellan'],
          names: ['Jennifer L. McClellan', 'Jennifer Mcclellan', 'Mcclellan, Jennifer'],
        },
        {
          name: 'Joan E. "Andrews" Bell', party: 'Independent', fecId: null,
          ids: ['va-rep-dist4-2026-jbell'],
          names: ['Joan E. "Andrews" Bell', 'Bell, Joan E.'],
        },
        {
          name: 'Robert P. "Family Man" Murray, Jr.', party: 'Republican', fecId: null,
          ids: ['va-rep-dist4-2026-rmurray'],
          names: ['Robert P. "Family Man" Murray, Jr.', 'Murray, Robert P.'],
        },
      ],
    },
    {
      districtKey: 'cd:5105',
      statewide: false,
      entries: [
        {
          name: 'Cooke C. Harvey', party: 'Independent', fecId: 'H6VA05241',
          ids: ['3dc4efb2-0093-406b-9b0e-2b4e461b0628', 'va-rep-dist5-2026-charvey'],
          names: ['Cooke C. Harvey', 'Cooke Costa Harvey', 'Harvey, Cooke Costa'],
        },
        {
          name: 'John J. McGuire III', party: 'Republican', fecId: 'H0VA07133',
          ids: ['e3b3562c-44c2-457e-a2aa-14dcaf248083', 'va-rep-dist5-2026-jmcguire'],
          names: ['John J. McGuire III', 'John Mcguire', 'Mcguire, John J. Mr. Iii'],
        },
        {
          name: 'Tom S. P. Perriello', party: 'Democratic', fecId: 'H6VA05217',
          ids: ['3e06461b-0441-486f-ad56-e59517d12b7b', 'va-rep-dist5-2026-tperriello'],
          names: ['Tom S. P. Perriello', 'Thomas Perriello', 'Perriello, Thomas'],
        },
      ],
    },
    {
      districtKey: 'cd:5106',
      statewide: false,
      entries: [
        {
          name: 'Ben L. Cline', party: 'Republican', fecId: 'H8VA06104',
          ids: ['454a08d2-070f-40f4-a726-1407820458cc', 'va-rep-dist6-2026-bcline'],
          names: ['Ben L. Cline', 'Benjamin Lee Cline', 'Cline, Benjamin Lee'],
        },
        {
          name: 'Beth A. Macy', party: 'Democratic', fecId: 'H6VA06173',
          ids: ['fe16b7ad-9318-450b-aa39-1af9bf68d966', 'va-rep-dist6-2026-bmacy'],
          names: ['Beth A. Macy', 'Beth Macy', 'Macy, Beth'],
        },
      ],
    },
    {
      districtKey: 'cd:5107',
      statewide: false,
      entries: [
        {
          name: 'Alaha Ahrar', party: 'Independent', fecId: null,
          ids: ['va-rep-dist7-2026-aahrar'],
          names: ['Alaha Ahrar', 'Ahrar, Alaha Ms.'],
        },
        {
          name: 'Doug A. Ollivant', party: 'Republican', fecId: 'H6VA07205',
          ids: ['a45fe787-b4f6-40ca-85e2-c7688af274c8', 'va-rep-dist7-2026-dollivant'],
          names: ['Doug A. Ollivant', 'Douglas Ollivant', 'Ollivant, Douglas'],
        },
        {
          name: 'Eugene S. Vindman', party: 'Democratic', fecId: 'H4VA07234',
          ids: ['98e2c11c-0ccc-46af-ad6f-292d3687f096', 'va-rep-dist7-2026-yvindman'],
          names: ['Eugene S. Vindman', 'Yevgeny \'eugene\' Vindman', 'Vindman, Yevgeny \'Eugene\''],
        },
        {
          name: 'Joshua E. Ertle', party: 'Independent', fecId: null,
          ids: ['va-rep-dist7-2026-jertle'],
          names: ['Joshua E. Ertle', 'Ertle, Joshua'],
        },
        {
          name: 'Randall A. Terry', party: 'Independent', fecId: 'H6VA07312',
          ids: ['d968b6fb-c751-4908-b353-9ec2a405faad', 'va-rep-dist7-2026-rterry'],
          names: ['Randall A. Terry', 'Randall Terry', 'Terry, Randall'],
        },
        {
          name: 'Taner E. Demirci Lopez', party: 'Libertarian', fecId: null,
          ids: [],
          names: ['Taner E. Demirci Lopez'],
        },
      ],
    },
    {
      districtKey: 'cd:5108',
      statewide: false,
      entries: [
        {
          name: 'Donald S. Beyer, Jr.', party: 'Democratic', fecId: 'H4VA08224',
          ids: ['0010f697-c22a-469f-8115-308caea4c178', 'va-rep-dist8-2026-dbeyer'],
          names: ['Donald S. Beyer, Jr.', 'Donald Sternoff Jr. Beyer', 'Beyer, Donald Sternoff Jr.'],
        },
        {
          name: 'Shelly M. Arnoldi', party: 'Libertarian', fecId: null,
          ids: [],
          names: ['Shelly M. Arnoldi'],
        },
        {
          name: 'Tim S. Sharman', party: 'Independent', fecId: null,
          ids: ['va-rep-dist8-2026-tsharman'],
          names: ['Tim S. Sharman', 'Sharman, Tim'],
        },
        {
          name: 'Tony A. Sabio', party: 'Republican', fecId: 'H6VA08252',
          ids: ['5d3a322f-d1e8-4448-b6fa-f3c5506095ee', 'va-rep-dist8-2026-tsabio'],
          names: ['Tony A. Sabio', 'Tony Sabio', 'Sabio, Tony'],
        },
      ],
    },
    {
      districtKey: 'cd:5109',
      statewide: false,
      entries: [
        {
          name: 'H. Morgan Griffith', party: 'Republican', fecId: 'H0VA09055',
          ids: ['6c682f37-0c0f-4cc4-9c99-35173bd790f1', 'va-rep-dist9-2026-hgriffith'],
          names: ['H. Morgan Griffith', 'H Morgan Griffith', 'Griffith, H Morgan'],
        },
        {
          name: 'Joy A. Powers', party: 'Democratic', fecId: 'H6VA09136',
          ids: ['a1180298-254b-44d9-b27e-80e388b9a6f2', 'va-rep-dist9-2026-jpowers'],
          names: ['Joy A. Powers', 'Joy Powers', 'Powers, Joy'],
        },
      ],
    },
    {
      districtKey: 'cd:5110',
      statewide: false,
      entries: [
        {
          name: 'Ahsen Mujeeb Malik', party: 'Independent', fecId: null,
          ids: ['va-rep-dist10-2026-amalik'],
          names: ['Ahsen Mujeeb Malik', 'Malik, Ahsen Mujeeb'],
        },
        {
          name: 'Dave T. Beckwith', party: 'Republican', fecId: 'H2VA10273',
          ids: ['95d62793-3ca8-4d6c-ab52-c6bcd595a788', 'va-rep-dist10-2026-dbeckwith'],
          names: ['Dave T. Beckwith', 'David Beckwith', 'Beckwith, David'],
        },
        {
          name: 'Suhas Subramanyam', party: 'Democratic', fecId: 'H4VA10279',
          ids: ['4a387719-93b6-408f-8673-4c73cc8b3b5a', 'va-rep-dist10-2026-ssubramanyam'],
          names: ['Suhas Subramanyam', 'Subramanyam, Suhas'],
        },
      ],
    },
    {
      districtKey: 'cd:5111',
      statewide: false,
      entries: [
        {
          name: 'Arthur G. Purves', party: 'Republican', fecId: null,
          ids: ['va-rep-dist11-2026-apurves'],
          names: ['Arthur G. Purves', 'Purves, Arthur Grahame Mr.'],
        },
        {
          name: 'Dianne L. Blais', party: 'Green', fecId: null,
          ids: ['va-rep-dist11-2026-dblais'],
          names: ['Dianne L. Blais', 'Blais, Dianne L'],
        },
        {
          name: 'James R. Walkinshaw', party: 'Democratic', fecId: 'H6VA11066',
          ids: ['559f72ff-c0bd-4cb4-9f1f-fbe475b26295', 'va-rep-dist11-2026-jwalkinshaw'],
          names: ['James R. Walkinshaw', 'James Walkinshaw', 'Walkinshaw, James'],
        },
      ],
    },
  ],
}
